export const KITS_NEED_UPDATE = 'orgs/kits/KITS_NEED_UPDATE';

export const kitsNeedUpdate = payload => ({
  type: KITS_NEED_UPDATE,
  payload,
});
